import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { TransferableEntity } from "../../types/ConfigurationTransfer";

/**
 * RTK Query API for Configuration Transfer operations
 */
export const configurationTransferApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        /**
         * Fetches the list of transferable entities (database tables) for a specific data group
         * @param id - The ID of the data group
         * @returns List of transferable entities with their dependencies and metadata
         */
        getTransferableEntities: builder.query<TransferableEntity[], number>({
            query: (id) => ({
                url: `${ResourceName.DATA_GROUPS}/${id}/transferable-entities`,
                method: "GET",
            }),
            providesTags: (_result, _error, id) => [{ type: ResourceName.DATA_GROUPS as const, id: `${id}-transferable-entities` }],
        }),
    }),
});

export const { useGetTransferableEntitiesQuery } = configurationTransferApi;
